'use client';

import type { CSSProperties } from 'react';
import './footer-mobile.scss';
import MobileNavigationBar from '@/components/Mobile/MobileNavigationBar';
import type { ProjectModel } from '@/lib/models/Project';

interface Props {
  isTitle: boolean;
  project?: ProjectModel;
  onBack: () => void;
  onNext: () => void;
  onViewWork: () => void;
  hideBorder?: boolean;
}

export default function FooterMobile({ isTitle, project, onBack, onNext, onViewWork, hideBorder }: Props) {
  const borderClass = isTitle || project ? 'footer-mobile-border footer-mobile-border--transparent' : 'footer-mobile-border';

  return (
    <div className={`footer-mobile ${hideBorder ? 'footer-mobile--border-hidden' : ''}`}>
      <div className={borderClass} />
      {project && <div className='footer-mobile-gradient' />}
      <MobileNavigationBar
        backLabel={isTitle ? 'CONTACT US' : 'BACK'}
        onBack={onBack}
        onNext={onNext}
        gradient={false}
      >
        {project && (
          <button
            type='button'
            className='footer-view-button letter-scrambler'
            style={{ '--footer-accent': project.mobileAccentColor } as CSSProperties}
            onClick={onViewWork}
          >
            VIEW THE WORK
          </button>
        )}
      </MobileNavigationBar>
    </div>
  );
}
